import React from 'react'
import { Link } from 'react-router'
import { Container, Row, Col, Button, InputGroup, InputGroupAddon, Input, Label, FormGroup } from 'reactstrap';

import Loader from '../../../core/components/Loader'


class RefusalChoice extends React.Component {

	constructor(props) {
		  super(props);
		  this.state={
		  	date:null,
		  	time:null,
		  	place:null
		  }
	}

	setDate(event){
		this.setState({date:event.target.value})
	}

	setTime(event){
		this.setState({time:event.target.value})
	}

	setPlace(event){
		this.setState({place:event.target.value})
	}


	validDate(){
		if(this.state.date && this.state.time && this.state.place){
			var datetime = this.state.date+" "+this.state.time
			this.props.onSubmit({
				rdv:datetime,
				rdv_place:this.state.place
			})
		}
	}


	render(){
		const { provider, status } = this.props

		return(
			<div className="background-white">
                  <div className="login-page status-page">

                        <Row>
                            <Col>
                                <div className="bloc-right center close" onClick={() => this.props.onClose()}>X</div>
                            </Col>
                        </Row>

                        <div className="login-container">
                            <Row>
                                <Col>
                                    <div className="login-title">Date de rendez-vous</div>
                                    <div className="login-company"> {provider.company} </div>
                                    <div className="login-subitle">Ajouter une date de rendez-vous </div>
                                </Col>
                            </Row>

                            <div className="bloc-login">
				                <form  role="form" >

				                        <FormGroup>
								          <Label for="exampleDate">Date</Label>
								          <Input type="date" name="date" id="exampleDate" placeholder="Date" onChange={(event) => this.setDate(event)} required />
								        </FormGroup>

							           <FormGroup>
								          <Label for="exampleTime">Heure</Label>
								          <Input type="time" name="time" id="exampleTime" placeholder="Heure" onChange={(event) => this.setTime(event)} required />
								        </FormGroup>

								        <FormGroup>
								          <Label for="exampleTime">Adresse complète</Label>
								          <Input type="text" name="rdv_place" onChange={(event) => this.setPlace(event)} required />
								        </FormGroup>

				                     {status.pending &&
				                     	<Loader />
				                     ||
					                     <div className="center validate">
					                        <Button className="btn-green" onClick={() => this.validDate() }>Valider</Button>
					                     </div>
				                     }

				                </form>
				            </div>

                        </div>

                        <Row className="bloc-register center">
                            <Col>
                                <div className="register-subtitle"><a onClick={() => this.props.onBack()}>Retour à l'étape précédente</a></div>
                            </Col>
                        </Row>

                  </div>
            </div>
		)
	}
}


export default RefusalChoice



// WEBPACK FOOTER //
// ./src/provider/components/status/MeetingChoice.js